<script>
  import AppShell from './app-shell.svelte'
  import Queue from './queue.svelte'
  import QueueList from './queue-list.svelte'


  let queueId

  const updateSelectedQueue = function () {
    if (location.hash.length > 1) {
      queueId = location.hash.slice(1)
    } else {
      queueId = undefined
    }
  }

  updateSelectedQueue()
</script>

<svelte:window on:hashchange={updateSelectedQueue} />

<AppShell>
  {#if queueId}
    <Queue {queueId} />
  {:else}
    <QueueList />
  {/if}
</AppShell>
